export default "__VITE_ASSET__RDsTKNXs__"